import { addFilters, selectFilters, selectFiltersTypes, selectLocation, updateLocation } from 'containers/Maps/menu/filtersSlice'
import { resetMapOptions, selectMapOptions, updateMapOption } from 'containers/Maps/Map/mapSlice'
import { DISTANCE_LIST } from 'containers/Maps/Map/mapUtils'
import { useReduxDispatch, useReduxSelector } from 'store'
import LocationSelect from 'components/LocationSelect'
import ArrowBtn from 'components/buttons/ArrowBtn'
import { LOCATION_STATES } from 'utils/constants'
import useTranslation from 'hooks/useTranslation'
import Select from 'components/inputs/Select'
import { useHistory } from 'react-router-dom'
import Input from 'components/inputs/Input'
import React, { Fragment } from 'react'

interface FilterFields {
  name: string
  field: string
  where: string
  type: string
  operator: string
  options: FilterFieldsOption[]
}

interface FilterFieldsOption {
  value: any
  name: string
  type?: string
  field?: string
  where?: string
}

const LIMIT = 3
const Filters: React.FC = () => {
  const filtersFields = useReduxSelector(selectFiltersTypes)
  const mapOptions = useReduxSelector(selectMapOptions)
  const location = useReduxSelector(selectLocation)
  const filters = useReduxSelector(selectFilters)

  const { t } = useTranslation('filters')
  const dispatch = useReduxDispatch()
  const { push } = useHistory()

  const updateFilter = (name: string, where: string, value: any = '', additionalName = '') => {
    const newValue = additionalName ? { ...filters[where][name], [additionalName]: value } : value
    if (value !== '') {
      dispatch(addFilters({ ...filters, [where]: { ...filters[where], [name]: newValue } }))
    } else {
      const copy = structuredClone(filters[where])
      if (additionalName) {
        delete copy[name][additionalName]
        if (Object.keys(copy[name]).length === 0) {
          delete copy[name]
        }
      } else {
        delete copy[name]
      }
      dispatch(addFilters({ ...filters, [where]: copy }))
    }
  }

  return (
    <div className='search__filters group'>
      <div className='search__filters__list'>
        <div className='search__filters__item'>
          <LocationSelect
            secondaryTheme
            address={location}
            voivodship={mapOptions.voivodship}
            clearAddress={() => {
              dispatch(resetMapOptions())
              dispatch(updateLocation(''))
            }}
            setAddress={(address, mapOption) => {
              dispatch(updateLocation(address))
              dispatch(updateMapOption(mapOption))
            }}
          />
        </div>
        <div className='search__filters__item --100'>
          <Select
            secondaryTheme
            label={t('distance')}
            disabled={!location}
            value={mapOptions.distance || DISTANCE_LIST[0]}
            options={DISTANCE_LIST.map(value => ({ value, name: `${value} km` }))}
            setValue={value => {
              dispatch(updateMapOption({ distance: value }))
            }}
          />
        </div>
        {Object.values(filtersFields as Record<string, FilterFields>)
          .filter(({ field, type }) => field && field !== 'categoryId' && field !== 'location' && field !== 'distance' && field !== 'area' && field !== 'sqmPrice' && type !== 'section')
          .map(({ name, where, field, type, options }, idx) => {
            if (idx > LIMIT - 1) return null
            return type === 'range'
              ? <Fragment key={field}>
                <div className='search__filters__item --200'>
                  <Input
                    type='number'
                    name={`${name}_od`}
                    label={`${name} ${t('from')}`}
                    placeholder={t('enterValue')}
                    value={filters[where][field]?.min || ''}
                    changeHandler={e => {
                      updateFilter(field, where, e.target.valueAsNumber || '', 'min')
                    }} />
                </div>
                <div className='search__filters__item --200'>
                  <Input
                    type='number'
                    name={`${name}_do`}
                    label={`${name} ${t('to')}`}
                    placeholder={t('enterValue')}
                    value={filters[where][field]?.max || ''}
                    changeHandler={e => {
                      updateFilter(field, where, e.target.valueAsNumber || '', 'max')
                    }} />
                </div>
              </Fragment>
              : type === 'select'
                ? <div
                  key={field}
                  className='search__filters__item --200'>
                  <Select
                    label={name}
                    secondaryTheme
                    options={options}
                    value={filters[where][field] || ''}
                    setValue={value => {
                      const newVal = value === 'true' ? true : value
                      updateFilter(field, where, newVal)
                    }}
                  />
                </div>
                : null
          })}
      </div>
      <ArrowBtn
        text={t('filters')}
        action={() => {
          push(window.location.pathname, LOCATION_STATES.popup('filters'))
        }}
      />
    </div>
  )
}

export default Filters